import { render, staticRenderFns } from "./ConsentForm.vue?vue&type=template&id=583fe557&scoped=true"
import script from "./ConsentForm.vue?vue&type=script&lang=js"
export * from "./ConsentForm.vue?vue&type=script&lang=js"
import style0 from "./ConsentForm.vue?vue&type=style&index=0&id=583fe557&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583fe557",
  null
  
)

export default component.exports